/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ai-mate.agent-message.error': '채팅 새로 고침',
  'ai-mate.agent-message.error.aup-link-text': '사용 제한 정책',
  'ai-mate.agent-message.error.aup-one': '해당 프롬프트에는 응답할 수 없습니다.',
  'ai-mate.agent-message.error.aup-two':
    '프롬프트가 Atlassian의 {link}을 준수하지 않을 수 있습니다. 다른 프롬프트를 시도하세요.',
  'ai-mate.agent-message.error.copy-trace-id': '추적 ID 복사',
  'ai-mate.agent-message.error.network-error': '네트워크 문제가 있는 것 같습니다.',
  'ai-mate.agent-message.error.resend': '메시지 다시 보내기',
  'ai-mate.agent-message.error.trace-id': '추적 ID: {traceId}',
  'ai-mate.browse-agents-view.close-button': '에이전트 보기 닫기',
  'ai-mate.browse-agents-view.header-title': '에이전트 찾아보기',
  'ai-mate.chat-history.conversationLimit':
    '이전 채팅을 찾고 계십니까? AI가 원활하게 작동하도록 30일 후에 채팅 기록을 지웁니다.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': '최근에 내가 기여한 Confluence는 무엇입니까?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': '나에게 할당된 모든 Jira 티켓을 찾습니다.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': '출장 정책은 어떻게 됩니까?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4': '마케팅 캠페인을 위한 Confluence 페이지 초안을 작성합니다.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': '프로젝트 타임라인을 어떻게 만들 수 있습니까?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': '잠재 고객에게 보낼 후속 조치 이메일을 작성합니다.',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': "'사용자'가 작성한 풀리퀘스트는 무엇입니까?",
  'ai-mate.chat-history.empty-state.browse-agents-button-text': '에이전트 찾아보기',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Rovo 에이전트와 채팅',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': '이 스페이스 정보',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': '이 스페이스에 대한 인사이트',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': '스페이스 제안 사항',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1': '내가 작성한 페이지에 새로운 활동이 있어?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10': '내가 게시한 페이지에 `사용자`가 댓글을 추가했어?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': "'페이지'의 핵심 요점은 무엇입니까?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': '나를 멘션하는 새 댓글이 있습니까?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3': '이 스페이스에서 최근에 게시된 페이지를 요약해 줘.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4': '지난주에 내가 페이지에 기여한 내용을 요약해 줘.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    '이 `페이지`를 기술 분야 이외의 사용자도 이해할 수 있도록 작성해 줘.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6': '프로젝트 관리를 위한 전략 템플릿을 만들어 줘.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7': '일반적인 고객 문제에 대한 어떤 조사 결과가 있어?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8':
    '내 팀원 중에 이번 주에 새 페이지를 게시한 사용자가 있어?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9': '`사용자`가 이번 주에 새 페이지를 게시했어?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': '이 페이지의 글 수준을 향상할 수 있습니까?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': '이 페이지의 핵심 요약을 작성합니다.',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': '다른 관련 페이지의 링크를 제공하세요.',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': '이 페이지 정보',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': '이 페이지에서 더 보기',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': '페이지 제안 사항',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': '지금 보고 있는 것을 요약해 줘.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': '이 페이지의 댓글을 요약합니다.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3': '초보자에게 설명하듯이 이 페이지를 설명해 줘.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4': '누가 이 페이지를 작성했고 어떤 팀에 속해 있어?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5': '지난주에 이 페이지에서 바뀐 내용이 있습니까?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': '이 화이트보드 정보',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': '이 화이트보드에 대해 자세히 알아보기',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': '이 화이트보드에 대한 인사이트',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': '지금 보고 있는 것을 요약해 줘.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    '여기에 보이는 패턴 또는 트렌드를 강조 표시하세요.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    '이 화이트보드에 캡처된 주요 작업 항목 또는 결정을 식별하세요.',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': '생산성 향상',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': '콘텐츠 초안 작성',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': '정보 찾기',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': '사용자 찾기',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': '답변 받기',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': '생산성 측정',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': '내용 바꾸어 말하기',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': '최신 정보 파악',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': '내용 요약',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>작성자:</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': '안녕하세요, {userName} 님',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Rovo Chat 및 에이전트 살펴보기',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': '대화를 시작하는 문구를 고르거나 무엇이든 물어보세요.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': '이번 주에 업데이트된 Jira 이슈를 찾습니다.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    '이번 주에 업데이트된 Jira 업무 항목을 찾습니다.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': '가장 높은 우선 순위가 지정된 Jira 이슈는 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    '가장 높은 우선 순위가 지정된 Jira 업무 항목은 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': '나를 멘션하는 댓글이 추가된 Jira 이슈는 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    '나를 멘션하는 댓글이 추가된 Jira 업무 항목은 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': '`Jira 이슈`에 대한 댓글을 요약해 줘.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    '`Jira 업무 항목`에 대한 댓글을 요약합니다.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': '사용자 스토리를 위한 설명 템플릿을 만들어 줘.',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': '이 이슈 정보',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': '이 업무 항목 정보',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': '이 이슈에서 더 보기',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': '이 업무 항목에서 더 보기',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': '이 이슈에 대한 인사이트',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': '이 업무 항목에 대한 인사이트',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': '이슈 제안 사항',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': '업무 항목 제안 사항',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': '비슷한 Jira 이슈가 있습니까?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh': '비슷한 Jira 업무 항목이 있습니까?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': '설명을 개선하려면 어떻게 해야 합니까?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': '이 이슈에는 어떤 레이블을 추가할 수 있습니까?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    '이 업무 항목에는 어떤 레이블을 추가할 수 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': '이 프로젝트에 대해',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': '이 프로젝트에 대한 인사이트',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': '이 프로젝트에서 더 보기',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': '프로젝트 제안 사항',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': '어떤 업무가 한동안 진행되지 않았어?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': '비슷한 Jira 이슈를 찾아서 그룹화합니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    '비슷한 Jira 업무 항목을 찾아서 그룹화합니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11': '상위 이슈와 연결되지 않은 Jira 이슈가 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    '상위 업무 항목에 연결되지 않은 Jira 업무 항목이 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12': '`Jira 이슈` 설명을 가져와서 모범 사례에 맞게 정렬해 줘.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    '`Jira 업무 항목` 설명을 사용하여 모범 사례에 맞게 정렬합니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': '`Jira 이슈`에 대한 댓글을 요약해 줘.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    '`Jira 업무 항목`에 대한 댓글을 요약합니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': '사용자 스토리를 위한 설명 템플릿을 만들어 줘.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    '사용자 스토리를 위한 설명 템플릿을 만듭니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': '차단된 Jira 이슈가 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh': '차단된 Jira 업무 항목이 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    '현재 "진행 중"인 Jira 이슈를 나열하고 담당자별로 그룹화합니다.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    "현재 '진행 중'인 Jira 업무 항목을 나열하고 담당자별로 그룹화합니다.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': '`사용자`에게 할당된 이슈가 몇 개야?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    '`사용자`에게 할당된 업무 항목이 몇 개입니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    '`사용자`가 이 스프린트에서 Jira 이슈에 추가한 댓글이 있어?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    '`사용자`가 이 스프린트에서 Jira 업무 항목에 추가한 댓글이 있습니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': '할당되지 않은 Jira 이슈는 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    '할당되지 않은 Jira 업무 항목은 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': '가장 오래 미해결 상태인 Jira 이슈가 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    '가장 오래 미해결 상태인 Jira 업무 항목이 무엇입니까?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': '작업이 가장 많은 사용자는 누구입니까?',
  'ai-mate.chat-history.empty-state.message': '답변을 받고 새로운 아이디어를 창출하고 일상적인 작업 속도를 높이세요.',
  'ai-mate.chat-history.empty-state.suggestion1': '내 티켓 중에 기한이 초과된 것이 있습니까?',
  'ai-mate.chat-history.empty-state.suggestion2': '다음에는 어떤 작업을 해야 합니까?',
  'ai-mate.chat-history.empty-state.suggestion3': '한 주에 대한 업데이트 작성',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': '제안 사항',
  'ai-mate.chat-history.message-research.research-completed-notification-body':
    '조사가 완료되어 확인할 준비가 되었습니다.',
  'ai-mate.chat-history.message-research.research-completed-notification-title': 'Rovo Chat이 조사를 완료했습니다',
  'ai-mate.chat-history.message-research.research-expandable.collapse': '접기',
  'ai-mate.chat-history.message-research.research-expandable.expand': '펼치기',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': '관련 정보 검색 중...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, other {{count}개 소스}}',
  'ai-mate.chat-history.message-research.title': '심층 조사',
  'ai-mate.chat-history.message-research.view-sources-button-label': '{count, plural, other {{count}개 소스}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': '취소',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': '확인',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button': '이 작업을 완료하는 동안 문제가 발생했습니다',
  'ai-mate.chat-input.actions-button.label': '요소 삽입',
  'ai-mate.chat-input.add-a-link-button.label': '링크 추가',
  'ai-mate.chat-input.deep-research-button.label': '심층 조사',
  'ai-mate.chat-input.deleted-agent-icon-label': '삭제된 에이전트',
  'ai-mate.chat-input.deleted-agent-start-new-chat': '새 채팅 시작',
  'ai-mate.chat-input.deleted-agent-warning': '이 에이전트를 삭제했습니다.',
  'ai-mate.chat-input.drag-and-drop-message': '더 나은 결과를 얻도록 끌어서 놓아 컨텍스트를 추가하세요',
  'ai-mate.chat-input.file-close-icon-label': '파일 제거',
  'ai-mate.chat-input.file-error-icon-label': '파일을 로드하는 동안 오류',
  'ai-mate.chat-input.link-type-ahead-button.label': '링크 추가',
  'ai-mate.chat-input.mention-someone-button.label': '사용자 또는 팀 멘션',
  'ai-mate.chat-input.mention-type-ahead-button.label': '다른 사용자 멘션',
  'ai-mate.chat-input.open-chat-input-buttons-label': '채팅 입력 버튼 열기',
  'ai-mate.chat-input.send-button.label': '제출',
  'ai-mate.chat-input.stop-generating-button.label': '생성 중지',
  'ai-mate.chat-input.store-user-messages.label': '답변 품질 향상에 도움이 되도록 이 메시지를 기록',
  'ai-mate.chat-input.web-search-button.label': '검색',
  'ai-mate.chat-main-header.back-button.label': '뒤로',
  'ai-mate.chat-main-header.copy-agent-link-button.label': '링크 복사',
  'ai-mate.chat-main-header.default-agent-name': '채팅',
  'ai-mate.chat-main-header.edit-agent-button.label': '편집',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL 복사됨',
  'ai-mate.chat-view.chat-item.chat-delete-label': '삭제',
  'ai-mate.chat-view.chat-item.chat-rename-label': '이름 변경',
  'ai-mate.chat-view.chat-item.options-button-label': '채팅 옵션',
  'ai-mate.content-renderer.profile-card.view-profile-button': '프로필 보기',
  'ai-mate.content-renderer.view-code-button-label': '분석 보기',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': '취소',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    '삭제하려고 하는 대화가 존재하지 않습니다.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': '삭제',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    '"{name}" 대화를 삭제하시겠습니까?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    '대화를 삭제하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    '이 대화를 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': '취소',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    '편집하려는 채널이 존재하지 않습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': '이름',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    '대화를 편집하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': '대화 편집',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    '이름이 현재 이름과 같습니다.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': '저장',
  'ai-mate.conversation-list-view.back-button.label': '뒤로',
  'ai-mate.conversation-list-view.close-chat-button.label': '채팅 닫기',
  'ai-mate.conversation-list-view.header-title': '채팅 기록',
  'ai-mate.conversation-list-view.new-chat-button.label': '새 채팅',
  'ai-mate.conversation-list-view.no-chat': '결과 없음',
  'ai-mate.conversation-list-view.search-input.placeholder': '채팅 검색',
  'ai-mate.expander.hide-details': '세부 정보 숨기기',
  'ai-mate.expander.show-details': '세부 정보 자세히 보기',
  'ai-mate.footer.beta': '베타',
  'ai-mate.footer.info': '콘텐츠 품질은 다를 수 있습니다',
  'ai-mate.footer.info-truncated': '콘텐츠 품질은 다를 수 있습니다',
  'ai-mate.footer.info-updated': '콘텐츠는 사용자의 권한을 기반으로 하며 품질은 다를 수 있습니다',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.message-renderer.error': '문제가 지속되는 경우 Atlassian에 알려주세요.',
  'ai-mate.message-renderer.error-title': '콘텐츠를 로드할 수 없음',
  'ai-mate.message-renderer.hide-sources': '모든 소스 숨기기',
  'ai-mate.message-renderer.show-sources': '{count, plural, other {{count}개의 소스 표시}}',
  'ai-mate.message-renderer.sources.sources-title': '소스',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': '확인하지 못했습니다. 잠시 후에 다시 시도하세요.',
  'ai-mate.pubsub-listener.forge-auth-success-message': '확인했습니다. 프롬프트를 다시 보내세요.',
  'ai-mate.sidebar.agents-icon.text': '에이전트',
  'ai-mate.sidebar.agents-icon.tooltip': 'Rovo 에이전트 찾아보기',
  'ai-mate.sidebar.chat-icon.text': '채팅',
  'ai-mate.sidebar.chat-icon.tooltip': 'Rovo와 채팅',
  'ai-mate.sidebar.debug-mode-icon.tooltip': '디버그',
  'ai-mate.sidebar.get-help-icon.tooltip': '도움말 보기',
  'ai-mate.sidebar.give-feedback-icon.tooltip': '피드백 보내기',
  'ai-mate.sidebar.history-icon.text': '기록',
  'ai-mate.sidebar.history-icon.tooltip': '채팅 기록 보기',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description':
    '파일 유효성을 검사하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': '파일 유효성 검사에 실패함',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': '파일이 유효하지 않습니다',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    '{count, plural, other {"{fileNames}" 파일은 지원되지 않습니다. 이유: {reasons}}}',
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, other {{count,number}개의 파일 유형이 지원되지 않음}}',
  'ai-mate.upload-files-to-conversation.unknown-error': '파일을 업로드하는 동안 오류가 발생했습니다. 다시 시도하세요.',
  'ai-mate.upload-files-to-conversation.unsupported-file': '지원되지 않는 파일 유형',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': '파일 이름이 누락되었습니다',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': '파일 크기가 너무 큽니다',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type': '지원되지 않는 파일 유형입니다',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': '유효성 검사 결과를 알 수 없습니다',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': '유효성 검사 결과를 찾을 수 없습니다',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error':
    '알 수 없는 이유로 파일 유효성 검사에 실패했습니다',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, other {{secondsRemaining,number}초 정도 기다려 주세요}}',
  'chat-history.rate-limit-warning-description': '메시지를 너무 빠르게 보내고 있습니다. 잠시만 기다려 주세요.',
  'chatHistory.storeAssistant.badResponseLabel': '부적합한 응답',
  'chatHistory.storeAssistant.copyResponseLabel': '복사',
  'chatHistory.storeAssistant.goodResponseLabel': '좋은 응답',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': '이 컨텍스트 사용',
  'rovo-chat.data-sculptor-modal.cancel': '취소',
  'rovo-chat.data-sculptor-modal.no-data': '데이터 없음',
  'rovo-chat.data-sculptor-modal.title': '분석',
  'rovo-chat.file-upload-button.label': '파일 업로드',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, other {{maxFiles,number}개 파일 한도에 도달했습니다}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': '끌어서 놓아 컨텍스트 추가',
  'rovo-chat.message-file.icon-label': '파일',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': '페이지에 삽입',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': '삽입',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': '이슈에 삽입',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': '선택 항목 바꾸기',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    '이 기능은 현재 컨텍스트에서 지원되지 않습니다. 페이지에서 텍스트를 선택하거나 작성하거나 편집해 보세요.',
  'rovo-chat.store-assistant.sources-title': '출처:',
};
